/* Scroll container */
.wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Table */
.table {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  width: 100%;
  border-collapse: collapse;
}

/* Header cells */
.headerCell {
  text-align: start;
  font-weight: 600;
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--md-outline-variant);
  white-space: nowrap;
}

.headerCell[data-align="end"] {
  text-align: end;
}

/* Body cells */
.cell {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--md-outline-variant);
}

.cell[data-align="end"] {
  text-align: end;
}

.body tr:last-child .cell {
  border-bottom: none;
}

/* Dense variant */
.table[data-dense] .headerCell,
.table[data-dense] .cell {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  padding: var(--space-1) var(--space-2);
}

.clickable {
  cursor: pointer;
}

.clickable .cell {
  position: relative;
}

.clickable .cell::before {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .clickable:hover .cell::before {
    opacity: var(--state-hover);
  }
}

.clickable:focus-visible .cell::before {
  opacity: var(--state-focus);
}

.clickable:active .cell::before {
  opacity: var(--state-pressed);
}
